import type {
  AdminProfessionalFavorites,
  AdminUserFavorite,
  ApiResponse,
  ProfessionalOnlineStatus,
} from '@klaro7/shared-types';

import api from '@/lib/api';

export interface FavoriteItem {
  id: string;
  userId: string;
  professionalId: string;
  professional: {
    firstName: string;
    lastName: string;
    avatar?: string;
    title: string;
  };
  /** Real-time availability of the professional (added by the favorites endpoint). */
  onlineStatus?: ProfessionalOnlineStatus;
  /** ISO timestamp of when the professional was last seen online. */
  lastSeenAt?: string | null;
  createdAt: string;
}

export async function getFavorites(): Promise<FavoriteItem[]> {
  const response = await api.get<ApiResponse<FavoriteItem[]>>('/favorites');
  return response.data.data;
}

export async function addFavorite(professionalId: string): Promise<void> {
  await api.post(`/favorites/${professionalId}`);
}

export async function removeFavorite(professionalId: string): Promise<void> {
  await api.delete(`/favorites/${professionalId}`);
}

export async function checkFavorite(professionalId: string): Promise<boolean> {
  const response = await api.get<ApiResponse<{ isFavorite: boolean }>>(
    `/favorites/check/${professionalId}`
  );
  return response.data.data.isFavorite;
}

// ─── Viste admin (super-admin, sola lettura) ────────────────────────────────

/** I consulenti che un cliente ha tra i preferiti. */
export async function getAdminUserFavorites(userId: string): Promise<AdminUserFavorite[]> {
  const response = await api.get<ApiResponse<AdminUserFavorite[]>>(`/favorites/admin/user/${userId}`);
  return response.data.data;
}

/** I clienti che hanno salvato un consulente. */
export async function getAdminProfessionalFavorites(
  professionalId: string
): Promise<AdminProfessionalFavorites> {
  const response = await api.get<ApiResponse<AdminProfessionalFavorites>>(
    `/favorites/admin/professional/${professionalId}`
  );
  return response.data.data;
}
